<template>
  <div class="express-settings-container">
    <div class="page-header"><h2><span class="breadcrumb-level">商城</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">设置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">收发货配置</span></h2></div>
    <div class="tabs-container">
      <el-card shadow="hover" class="address-card">
        <template #header>
          <div class="card-header">
            <span>发货地址设置</span>
            <el-button type="primary" size="small" @click="handleEdit" :loading="loading">
              {{ shippingAddress.id ? '编辑' : '新增' }}
            </el-button>
          </div>
        </template>
        <div v-if="shippingAddress.id" class="address-info">
          <div class="info-item">
            <span class="info-label">公司名称：</span>
            <span class="info-value">{{ shippingAddress.company_name }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">联系人：</span>
            <span class="info-value">{{ shippingAddress.name }} {{ shippingAddress.mobile }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">地址：</span>
            <span class="info-value">{{ shippingAddress.province }} {{ shippingAddress.city }} {{ shippingAddress.district }} {{ shippingAddress.address }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">状态：</span>
            <el-tag :type="shippingAddress.status ? 'success' : 'danger'">
              {{ shippingAddress.status ? '启用' : '禁用' }}
            </el-tag>
          </div>
        </div>
        <div v-else class="empty-address">
          <el-empty description="暂无发货地址，请点击新增按钮添加" />
        </div>
      </el-card>
    </div>

    <el-dialog v-model="dialogVisible" title="编辑发货地址" width="500px">
      <el-form ref="addressFormRef" :model="formData" label-position="top">
        <el-form-item label="公司名称">
          <el-input v-model="formData.company_name" placeholder="请输入公司名称" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="formData.name" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="formData.mobile" placeholder="请输入手机号" />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="display: flex; gap: 10px;">
          <el-form-item label="省份" style="flex:1">
            <el-input v-model="formData.province" placeholder="请输入省份" />
          </el-form-item>
          <el-form-item label="城市" style="flex:1">
            <el-input v-model="formData.city" placeholder="请输入城市" />
          </el-form-item>
          <el-form-item label="区县" style="flex:1">
            <el-input v-model="formData.district" placeholder="请输入区县" />
          </el-form-item>
        </div>
        <el-form-item label="详细地址">
          <el-input v-model="formData.address" placeholder="请输入详细地址" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading">
          {{ formData.id ? '保存' : '新增' }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import * as expressCompanyApi from '../../api/expressCompany'

const loading = ref(false)
const dialogVisible = ref(false)
const shippingAddress = ref({})

const formData = ref({
  company_name: '',
  name: '',
  mobile: '',
  province: '',
  city: '',
  district: '',
  address: '',
  status: 1,
})

const fetchAddress = async () => {
  loading.value = true
  try {
    const res = await expressCompanyApi.getShippingAddress()
    if (res.code === 200 && res.data) {
      shippingAddress.value = res.data
    }
  } catch {} finally {
    loading.value = false
  }
}

const handleEdit = () => {
  formData.value = {
    company_name: shippingAddress.value.company_name || '',
    name: shippingAddress.value.name || '',
    mobile: shippingAddress.value.mobile || '',
    province: shippingAddress.value.province || '',
    city: shippingAddress.value.city || '',
    district: shippingAddress.value.district || '',
    address: shippingAddress.value.address || '',
    status: shippingAddress.value.status ?? 1,
  }
  dialogVisible.value = true
}

const handleSubmit = async () => {
  loading.value = true
  try {
    const res = await expressCompanyApi.saveShippingAddress(formData.value)
    if (res.code === 200) {
      ElMessage.success('保存成功')
      dialogVisible.value = false
      fetchAddress()
    }
  } catch (e) {
    ElMessage.error(e.response?.data?.message || '保存失败')
  } finally {
    loading.value = false
  }
}

onMounted(() => fetchAddress())
</script>

<style scoped>
.address-card { margin-bottom: 20px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.info-item { padding: 8px 0; display: flex; }
.info-label { width: 100px; color: #666; flex-shrink: 0; }
.info-value { color: #333; }
.empty-address { padding: 40px 0; text-align: center; }
</style>
